import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { routes } from 'src/app/core/helpers/routes';
import {AdminService} from "../../../core/service/admin/admin.service";
import {AuthService} from "../../service/auth.service";

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrl: './signin.component.scss',
  standalone:false
})
export class SigninComponent {
  public routes = routes;
  formGroup!: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private authService: AuthService,
    private adminService:AdminService,
    private router: Router) { }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      'username': ['', Validators.required],
      'password': ['', Validators.required],
    });
  }

  onLogin() {
    this.authService.login().then(() => {
      this.authService.getVerifyUser()
      this.router.navigate([routes.events]);
    });
  }
}
